import moment from 'moment'
import { isProxy, markRaw, toRaw } from 'vue'
import ID from '../models/base/ID'
import { GraphRange } from '../models/flatbuff/common/graph-range'
import { GraphRange as FacilityGraphRange } from '../models/flatbuff/facility/graph-range'

export type TimeSeries = {[startDate: string]: {[key: string]: number}}
export type ApolloTimeSeries = {[key: string]: number | string}
export type TimeSeriesLimits = {start: string, end: string, minVal?: number, maxVal?: number}
export type TimeSeriesGraphCnf = {[key: string]: [number | string] | number[] | number | string | Set<ID> | Set<[ID, string, ID, ID]> }

export default {
  namespaced: true,
  state () {
    return {
      data: null as null | TimeSeries,
      timePlaceHolder: {} as TimeSeries,
      limits: null as null | GraphRange | FacilityGraphRange,
      conf: {} as TimeSeriesGraphCnf,
      sourceFormat: 'x',
      format: 'MM/DD/YYYY'
    }
  },
  mutations: {
    add (state: any, { data, dateKey, multiKey } : {data: ApolloTimeSeries[], dateKey: string, multiKey?: string}) {
      let addItem = (key: string, item: ApolloTimeSeries, obj: any) => {
        delete item[key]
        obj[key] = item
      }

      if (multiKey !== undefined) {
        addItem = (key: string, item: ApolloTimeSeries, obj: any) => {
          delete item[key]
          obj[key][item[multiKey]] = item
        }
      }

      if (Object.keys(state.timePlaceHolder).length > Object.keys(state.data || {}).length) {
        let sortedData: any
        if (isProxy(state.timePlaceHolder)) {
          sortedData = structuredClone(toRaw(state.timePlaceHolder))
        } else {
          sortedData = structuredClone(state.timePlaceHolder)
        }

        data.forEach((item: ApolloTimeSeries) => {
          const key = moment.utc(item[dateKey], state.sourceFormat).format(state.format)
          addItem(key, item, sortedData)
        })

        state.data = sortedData
      } else {
        data.forEach((item: ApolloTimeSeries) => {
          const key = moment.utc(item[dateKey], state.sourceFormat).format(state.format)
          addItem(key, item, state.data)
        })
      }
    },
    setLimits (state: any, limits : GraphRange) {
      state.limits = markRaw(limits)

      const sortedData = {} as TimeSeries
      const start = moment.utc(limits.start(), state.sourceFormat)
      const end = moment.utc(limits.end(), state.sourceFormat)

      while (start.isSameOrBefore(end)) {
        sortedData[start.format(state.format)] = {}
        start.add(1, 'day')
      }

      state.timePlaceHolder = sortedData
      state.data = null
    },
    setConf (state: any, conf: TimeSeriesGraphCnf) {
      state.conf = conf
    },
    resetStoreState (state: any) {
      state.data = null
      state.limits = null
      state.timePlaceHolder = {}
      state.conf = {}
    }
  }
}
